module.exports = __webpack_public_path__ + "img/图层 20.db4428e1.png";